import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, inject } from '@angular/core';

import { FsStore } from '@firestitch/store';

import { SidenavService } from '../../services/sidenav.service';
import { MatToolbar } from '@angular/material/toolbar';
import { FsNavModule } from '@firestitch/nav';
import { MatIcon } from '@angular/material/icon';

import { MatIconButton } from '@angular/material/button';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
    MatToolbar,
    FsNavModule,
    MatIcon,
    MatIconButton
],
})
export class HeaderComponent implements OnInit {
  private _store = inject(FsStore);
  private _sidenavService = inject(SidenavService);
  private _cdRef = inject(ChangeDetectorRef);


  public account;

  public ngOnInit(): void {
    this._store.observe('account')
      .subscribe((store) => {
        this.account = store.value;
        this._cdRef.markForCheck();
      });
  }

  public sideNavClick(): void {
    this._sidenavService.toggle();
  }

}
